<template>
<div class="site-detail">
    <Error @reload="getData()" v-if="networkError" />
    <div class="intro-page" v-else-if="showPage">
        <v-banner :site="merchant" />
        <div class="intro-wrapper">
            <div class="intro-brief">
                <div class="intro-name">
                    <div class="name">{{ merchant.name }}</div>
                    <div class="price" v-if="merchant.price === 0">{{ $t('home.free') }}</div>
                    <div class="price" v-else-if="merchant.price">{{ $t('common.symbol') }}{{ merchant.price / 100 }}{{ $t('common.eachPerson') }}</div>
                </div>
                <div class="place-rate" v-if="merchant.rating || merchant.reviews">
                    <Score :rating="merchant.rating" v-if="merchant.rating" />
                    <div class="place-review" v-if="merchant.reviews">{{ merchant.reviews }} {{ $t('home.comment') }}</div>
                </div>
            </div>
            <v-detail-content :detailArray="guideArray"
                              :site="merchant"
                              siteType="merchant" />
        </div>
        <v-recommendation v-if="merchant_items.length > 0" :list="merchant_items" />
        <div class="explore-around">
            <v-explore-list :sites="recommend.sites" :hotels="recommend.hotels" :merchants="recommend.merchants" />
        </div>
    </div>
</div>
</template>

<script>
import { getMerchantDetail } from '@/fetch/api'
import Error from '@/components/Error.vue'
import Score from '@/components/Score.vue'
import DetailContent from '@/components/scenic/DetailContent.vue'
import Banner from '@/components/scenic/Banner.vue'
import ExploreList from '@/components/scenic/ExploreList.vue'
import Recommendation from '@/components/scenic/Recommendation.vue'

export default {
    data () {
        return {
            siteId: '1',
            showPage: false,
            id: '',
            merchant: {},
            guideArray: [],
            recommend: {},
            merchant_items: [],
            networkError: false
        }
    },
    components: {
        Error,
        Score,
        'v-detail-content': DetailContent,
        'v-banner': Banner,
        'v-explore-list': ExploreList,
        'v-recommendation': Recommendation
    },
    created () {
        document.title = this.$t('poi.merchantTitle')
        this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
        })
        this.toast.show()
        navigator.geolocation.getCurrentPosition((res) => {
            const longitude = res.coords.longitude
            const latitude = res.coords.latitude
            this.geoData = {
                lon: longitude,
                lat: latitude
            }
            // console.log(longitude, latitude)
            if (longitude) {
                this.getData()
            }
        }, err => {
            this.geoData = {
                lon: 103.82241,
                lat: 1.2651
            }
            this.getData()
        }, { timeout: 5000, enableHighAccuracy: true })
    },
    watch: {
        '$route' () {
            this.getData()
        }
    },
    methods: {
        getData () {
            const params = {
                lon: this.geoData.lon,
                lat: this.geoData.lat
            }
            if (this.$route.query.language === 'zh') {
                params.locale = 'cn'
            } else {
                params.locale = 'en'
            }
            getMerchantDetail(this.$route.params.id, params).then(res => {
                this.networkError = false
                this.merchant = res.merchant
                this.merchant_items = res.merchant_items || []
                this.recommend = {
                    sites: res.sites,
                    hotels: res.hotels,
                    merchants: res.merchants
                },
                this.guideArray = this.processGuide(res.merchant)
                this.showPage = true
                this.toast.hide()
                window.scrollTo(0,0)
            }).catch(err => {
                console.log(err)
                this.toast.hide()
                this.networkError = true
            })
        },
        processGuide (site) {
            let guideArray = []
            if (site.description) {
                guideArray.push({
                    id: 'description',
                    text: this.$t('poi.merchantDesc'),
                    content: site.description
                })
            }
            if (site.open) {
                guideArray.push({
                    id: 'time',
                    text: this.$t('poi.mallTime'),
                    content: site.open
                })
            }
            if (site.contact_phone) {
                guideArray.push({
                    id: 'number',
                    text: this.$t('poi.numner'),
                    content: site.contact_phone
                })
            }
            if (site.website) {
                guideArray.push({
                    id: 'website',
                    text: this.$t('poi.website'),
                    content: site.website
                })
            }
            if (site.traffic_strategy) {
                guideArray.push({
                    id: 'traffic',
                    text: this.$t('poi.traffic'),
                    content: site.traffic_strategy
                })
            }
            if (site.address) {
                guideArray.push({
                    id: 'address',
                    text: this.$t('poi.address'),
                    content: site.address
                })
            }
            return guideArray
        },
    }
}
</script>

<style lang="scss" scoped>
.intro-page .intro-name {
    display: flex;
    justify-content: space-between;
}

.intro-page .name {
    padding-right: 20px;
    font-weight: bold;
    font-family: GothamBold;
}

.intro-page .price {
    font-size: 14px;
    color: #222215;
    font-weight: normal;
    flex-shrink: 0;
}
</style>